(() => {
  const SELECTORS = {
    section: '[data-review-with-slider]',
    swiper: '[data-rws-swiper]',
    prev: '.review-with-slider__btn--prev',
    next: '.review-with-slider__btn--next',
  };

  const init = (root) => {
    const swiperEl = root.querySelector(SELECTORS.swiper);
    if (!swiperEl) return;
    if (!window.Swiper) return;
    if (swiperEl.dataset.initialized === 'true') return;

    const slidesDesktop = Number(swiperEl.dataset.slidesDesktop || 3);
    const slidesMobile = Number(swiperEl.dataset.slidesMobile || 1);

    const prevEl = root.querySelector(SELECTORS.prev);
    const nextEl = root.querySelector(SELECTORS.next);

    // eslint-disable-next-line no-new
    new window.Swiper(swiperEl, {
      slidesPerView: slidesMobile,
      spaceBetween: 14,
      speed: 450,
      watchOverflow: true,
      navigation: {
        prevEl,
        nextEl,
      },
      breakpoints: {
        750: {
          slidesPerView: slidesDesktop,
          spaceBetween: 22,
        },
      },
    });

    swiperEl.dataset.initialized = 'true';
  };

  const boot = () => {
    document.querySelectorAll(SELECTORS.section).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target?.querySelector?.(SELECTORS.section) || e.target;
    if (root && root.matches?.(SELECTORS.section)) init(root);
  });
})();

